import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import {ReportsService} from '../../reports.service';
import {SelectedFilterValuesModel} from '../../../dialogs/grid-filter/selected-filter-values.model';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { FormsModule } from '@angular/forms';
import { CardOptionsComponent } from '../../../core/visual/card/options-card.component';

export interface UsersSummaryCurrentFilterData {
  filter: Array<SelectedFilterValuesModel>;
}

@Component({
    selector: 'app-mat-users-summary-filter-dialog',
    templateUrl: './mat-users-summary-filter-dialog.component.html',
    styleUrls: ['./mat-users-summary-filter-dialog.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        MatDialogTitle,
        MatIconButton,
        MatDialogClose,
        MatIcon,
        CdkScrollable,
        MatDialogContent,
        FormsModule,
        CardOptionsComponent,
        MatDialogActions,
        MatButton,
    ],
})
export class MatUsersSummaryFilterDialogComponent implements OnInit, OnDestroy {

  checkedExtensionOptions = [];
  checkedDepartmentOptions = [];

  constructor(public reportsService: ReportsService,
              public dialogRef: MatDialogRef<MatUsersSummaryFilterDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: UsersSummaryCurrentFilterData
  ) {
  }

  ngOnInit() {
    if (this.data.filter) {
      for (const selectedFilter of this.data.filter) {
        if (selectedFilter.filterKey === 'extensions') {
          this.checkedExtensionOptions = selectedFilter.values;
        } else if (selectedFilter.filterKey === 'departments') {
          this.checkedDepartmentOptions = selectedFilter.values;
        }
      }
    }
  }

  ngOnDestroy() {
  }

  getAccountsNames(lookupList: any[], selectedAccounts: string[]): string[] {
    const lookup = lookupList.filter(x => selectedAccounts.includes(x.value));

    return lookup.map(x => x.text);
  }

  closeSendConfirmPopup(action: string) {
    if (action === 'close') {
      this.dialogRef.close();
    } else {
      const filter: SelectedFilterValuesModel[] = [];

      if (this.checkedExtensionOptions.length > 0) {
        filter.push({
          filterKey: 'extensions',
          multiValue: true,
          title: 'User',
          values: this.checkedExtensionOptions,
          displayValues: this.getAccountsNames(this.reportsService.extensionsLookup, this.checkedExtensionOptions),
        });
      }

      if (this.checkedDepartmentOptions.length > 0) {
        filter.push({
          filterKey: 'departments',
          multiValue: true,
          title: 'Departments',
          values: this.checkedDepartmentOptions,
          displayValues: this.getAccountsNames(this.reportsService.departmentsLookup, this.checkedDepartmentOptions),
        });
      }

      this.dialogRef.close(filter);
    }
  }
}
